import { render, staticRenderFns } from "./px-list-header.vue?vue&type=template&id=3802ff6d&scoped=true&"
import script from "./px-list-header.vue?vue&type=script&lang=ts&"
export * from "./px-list-header.vue?vue&type=script&lang=ts&"
import style0 from "./px-list-header.vue?vue&type=style&index=0&id=3802ff6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3802ff6d",
  null
  
)

export default component.exports